module.exports = __webpack_public_path__ + "img/czleader2.b3093bc9.png";